import { Fragment } from "react";
import GiftBagCheck from "@/assets/images/3d-icons/gift-bag-check.png";
import GiftEnvelopePlane from "@/assets/images/3d-icons/gift-envelope-plane.png";
import GiftPlusWrapped from "@/assets/images/3d-icons/gift-plus-wrapped.png";
import { ArrowFatRight } from "@/components/shared/icons";
import { ListHeading } from "@/components/shared/list-header";
import { Typography } from "@/components/shared/typography";
import { Button, Image, View } from "@/components/ui";
import { links } from "@/constants";
import { openBrowser } from "@/lib/open-browser";

const HOW_IT_WORKS_ITEMS = [
  {
    icon: GiftPlusWrapped,
    title: "Choose a gift card",
  },
  {
    icon: GiftEnvelopePlane,
    title: "Send it to someone",
  },
  {
    icon: GiftBagCheck,
    title: "They redeem it",
  },
];

export function GiftCardHowItWorks() {
  return (
    <View className="px-4 py-6">
      <View className="mb-3">
        <ListHeading title="How It Works" />
      </View>
      <View className="bg-brand-primary-surface rounded-lg p-2">
        <View className="flex flex-row items-center gap-2">
          {HOW_IT_WORKS_ITEMS.map((item, index) => (
            <Fragment key={item.title}>
              <View className="flex flex-1 flex-col items-center gap-2">
                <Image src={item.icon} alt={item.title} width={48} height={48} />
                <Typography variant="body-sm" color="foreground-default" className="text-center">
                  {item.title}
                </Typography>
              </View>
              {index !== HOW_IT_WORKS_ITEMS.length - 1 && (
                <ArrowFatRight size={20} weight="fill" className="text-brand-primary" />
              )}
            </Fragment>
          ))}
        </View>
      </View>
      <View className="mt-3 flex flex-col items-center">
        <Button
          variant="secondary"
          color="CTA2"
          size={"md"}
          rounded="full"
          onClick={() => openBrowser(links.giftCard)}
          iconAlignment={"end"}
          iconName="arrowUpRight"
          iconColor="CTA2"
          iconSize={"md"}
        >
          Learn more
        </Button>
      </View>
    </View>
  );
}
